module.exports = __webpack_public_path__ + "img/Group-Deals.296b9691.svg";